import "./examinationNavbar.scss";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext, useState, useEffect } from "react";
import SegmentIcon from "@mui/icons-material/MenuOutlined";
import { serverUrl } from "../../temp";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";

const ExaminationNavbar = ({
  isOpen,
  toggle,
  selectedClassId,
  onClassChange,
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const [classes, setClasses] = useState([]);
  const [data, setData] = useState(null);
  const [isStaticClassDisplay, setIsStaticClassDisplay] = useState(false);
  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedCenterName, setSelectedCenterName] = useState("");
  const [loadingCenters, setLoadingCenters] = useState(false);
  const centerId = localStorage.getItem("center_id");

  // Initialize centers from localStorage
  useEffect(() => {
    const savedCenterId = localStorage.getItem("center_id");
    const savedCenterName = localStorage.getItem("center_name");

    if (savedCenterId) {
      setSelectedCenter(savedCenterId);
      setSelectedCenterName(savedCenterName || savedCenterId);
    }

    const adminData = JSON.parse(localStorage.getItem("admindata"));

    if (adminData) {
      setData(adminData);
      if (adminData.role_id == 0) {
        fetchCenters();
      }
    }

    // fetchCenters();
    fetchClasses();
  }, []);

  const fetchCenters = async () => {
    setLoadingCenters(true);
    try {
      const response = await fetch(`${serverUrl}/center_id`);
      const result = await response.json();

      if (result.status === "true" && result.data?.length > 0) {
        const centerOptions = result.data.map((c) => ({
          id: c.id.toString(),
          name: c.name,
        }));
        setCenters(centerOptions);

        // Update name if we have existing selection
        if (selectedCenter) {
          const currentCenter = centerOptions.find(
            (c) => c.id == selectedCenter,
          );
          if (currentCenter) {
            setSelectedCenterName(currentCenter.name);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    } finally {
      setLoadingCenters(false);
    }
  };

  // const fetchClasses = () => {
  //   fetch(`${serverUrl}/result_dashboard/class_dropdown?centerId=${centerId}`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.code) setClasses(data.data);
  //     })
  //     .catch((error) => console.error("Error in fetching classes", error));
  // };

  const fetchClasses = async (centerIdToFetch = centerId) => {
    try {
      const res = await fetch(
        `${serverUrl}/result_dashboard/class_dropdown?centerId=${centerIdToFetch}`,
      );
      const data = await res.json();
      if (data.code) {
        const fetchedClasses = data.data;
        setClasses(fetchedClasses);

        // ✅ Prefer previously selected class if it still exists
        const storedClassId = localStorage.getItem("class-id");
        const validStoredClass = fetchedClasses.find(
          (c) => c.id == storedClassId,
        );

        if (validStoredClass) {
          onClassChange(validStoredClass.id);
        } else if (fetchedClasses.length > 0) {
          onClassChange(fetchedClasses[0].id);
        } else {
          onClassChange(null);
        }
      }
    } catch (error) {
      console.error("Error in fetching classes", error);
    }
  };

  // const fetchClasses = async (centerIdToFetch = centerId) => {
  //   try {
  //     const res = await fetch(
  //       `${serverUrl}/result_dashboard/class_dropdown?centerId=${centerIdToFetch}`
  //     );
  //     const data = await res.json();
  //     if (data.code) {
  //       const fetchedClasses = data.data;
  //       setClasses(fetchedClasses);

  //       // Trigger onClassChange with the first class ID
  //       if (fetchedClasses.length > 0) {
  //         onClassChange(fetchedClasses[0].id);
  //       } else {
  //         onClassChange(null);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error in fetching classes", error);
  //   }
  // };

  // const handleCenterChange = (event) => {
  //   const newCenterId = event.target.value;
  //   const selectedCenterObj = centers.find((c) => c.id === newCenterId);

  //   setSelectedCenter(newCenterId);
  //   setSelectedCenterName(selectedCenterObj?.name || newCenterId);
  //   localStorage.setItem("center_id", newCenterId);
  //   localStorage.setItem("center_name", selectedCenterObj?.name || newCenterId);

  //   // Refetch classes for the new center
  //   fetchClasses();
  // };

  // Find class name based on ID

  const handleCenterChange = (event) => {
    const newCenterId = event.target.value;
    const selectedCenterObj = centers.find((c) => c.id === newCenterId);

    setSelectedCenter(newCenterId);
    setSelectedCenterName(selectedCenterObj?.name || newCenterId);
    localStorage.setItem("center_id", newCenterId);
    localStorage.setItem("center_name", selectedCenterObj?.name || newCenterId);

    fetchClasses(newCenterId); // ✅ Fetch classes and trigger onClassChange
  };

  const getClassName = (classId) => {
    const classObj = classes.find((c) => c.id == classId);
    return classObj ? classObj.name : "Loading...";
  };

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setFullscreen(false);
    } else {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    }
  };

  return (
    <div className="examinationNavbar">
      <div className="wrapper">
        <div className="left-section">
          {true && (
            // <button className="icon-button" onClick={toggle}>
            //   <SegmentIcon className="icon" />
            // </button>
            <button className="icon-button" onClick={toggle}>
              {isOpen ? (
                <KeyboardArrowLeftOutlinedIcon className="icon" />
              ) : (
                <KeyboardArrowRightOutlinedIcon className="icon" />
              )}
            </button>
          )}

          {/* Center Dropdown */}
          {/* <div className="center-dropdown">
            <FormControl size="small" sx={{ minWidth: 200, marginRight: 2 }}>
              <label style={{ fontSize: "12px", marginBottom: "4px", color: "#555" }}>
                Center
              </label>
              <Select
                value={selectedCenter}
                onChange={handleCenterChange}
                disabled={loadingCenters}
                displayEmpty
                renderValue={() => selectedCenterName || "Select Center"}
              >
                {loadingCenters ? (
                  <MenuItem disabled>Loading centers...</MenuItem>
                ) : centers.length === 0 ? (
                  <MenuItem disabled>No centers available</MenuItem>
                ) : (
                  centers.map((center) => (
                    <MenuItem key={center.id} value={center.id}>
                      {center.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </div> */}
          {data?.role_id == 0 && (
            <div className="horizontal-dropdown">
              <label className="dropdown-label">Center</label>
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <Select
                  value={selectedCenter}
                  onChange={handleCenterChange}
                  disabled={loadingCenters}
                  displayEmpty
                  renderValue={() => selectedCenterName || "Select Center"}
                >
                  {loadingCenters ? (
                    <MenuItem disabled>Loading centers...</MenuItem>
                  ) : centers.length === 0 ? (
                    <MenuItem disabled>No centers available</MenuItem>
                  ) : (
                    centers.map((center) => (
                      <MenuItem key={center.id} value={center.id}>
                        {center.name}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </div>
          )}

          {/* Class Dropdown */}
          {/* <div className="dropdown-group">
            <label style={{ fontSize: "12px", marginBottom: "4px", color: "#555", display: "block" }}>
              Class
            </label>
            {isStaticClassDisplay ? (
              <span className="class-display">
                <b>Class:</b> {getClassName(selectedClassId)}
              </span>
            ) : (
              <select
                value={selectedClassId}
                onChange={(e) => onClassChange(e.target.value)}
              >
                {classes.map((classItem) => (
                  <option key={classItem.id} value={classItem.id}>
                    {classItem.name}
                  </option>
                ))}
              </select>
            )}
          </div> */}
          <div className="horizontal-dropdown">
            <label className="dropdown-label">Class</label>
            {isStaticClassDisplay ? (
              <span className="class-display">
                <b>Class:</b> {getClassName(selectedClassId)}
              </span>
            ) : (
              <select
                value={selectedClassId}
                onChange={(e) => onClassChange(e.target.value)}
                className="native-class-dropdown"
              >
                {classes.map((classItem) => (
                  <option
                    key={classItem.group_id || classItem.class_id} // fallback if no group
                    value={classItem.class_id}
                  >
                    {classItem.class_name}
                    {classItem.group_name ? ` - ${classItem.group_name}` : ""}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>

        <div className="items">
          <div className="logo">
            <img
              src={`${process.env.PUBLIC_URL}/logos/EG-Logo-purple-icon.png`}
              alt="Logo"
              className="w-10 h-10 object-contain"
            />
          </div>
          <div className="item hidden lg:block">
            {fullscreen ? (
              <FullscreenExitOutlinedIcon
                className="icon"
                onClick={toggleFullscreen}
              />
            ) : (
              <FullscreenOutlinedIcon
                className="icon"
                onClick={toggleFullscreen}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExaminationNavbar;
